import { useEffect } from "react";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { useSelectedCareRecipient } from "../care_recipient/useSelectedCareRecipient";
import { useNavigate } from "react-router-dom";


export function useChangeCareRecipient(basePath: string): CareRecipientId | null {

    const navigate = useNavigate();
    const selectedCareRecipient = useSelectedCareRecipient();

    useEffect(() => {
        if (!selectedCareRecipient) {
            navigate("/");
            return;
        }
        navigate(`${basePath}/${selectedCareRecipient.id.value}`);
    }, [selectedCareRecipient]);

    if (!selectedCareRecipient) return null;
    return selectedCareRecipient.id;
}
